import React, { useMemo } from 'react';
import { useCurrentRefinements } from 'react-instantsearch-hooks-web';
import SearchFiltersMenu from './generic/SearchFiltersMenu';
import SearchFiltersRefinementList from './generic/SearchFiltersRefinementList';
import config from '../config/config';

const SearchFiltersGroupStatusAvail = () => {
	const { items } = useCurrentRefinements();

	const showMoveInWindow = useMemo( () => {
		const label = 'Move-In Ready';
		const statusItems = items.find( ( item ) => item.attribute === config.FILTER_ATTRIBUTES.availability );
		if ( ! statusItems ) {
			return false;
		}
		const hasSelectedItem = statusItems.refinements.find( ( item ) => item.label === label );
		return hasSelectedItem;
	}, [ items ] );

	return (
		<div className='tw-space-y-6'>
			<div>
				<SearchFiltersRefinementList attribute={config.FILTER_ATTRIBUTES.availability} label="Availability" />
			</div>
			{showMoveInWindow && (
				<SearchFiltersMenu
					attribute={config.FILTER_ATTRIBUTES.moveInWindow}
					id="move_in_window_menu"
					label="Select Move-In Time Frame (Months)"
				/>
			)}
		</div>
	);
};

export default SearchFiltersGroupStatusAvail;
